import React, { useEffect } from 'react';
import { toggleSnapping } from '../state/actions/toggle-snapping';
import { saveSnappingEnabled } from '../state/snapping-persistance';
import { isEventTargetInputElement } from '../utils/is-event-target-input-element';
import { useWriteContext, useCurrentStateAsRef } from '../utils/use-context';

export const SnappingShortcut: React.FC = () => {
  const { setState } = useWriteContext();
  const stateRef = useCurrentStateAsRef();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // input에서의 타이핑 및 시스템 단축키 캐처 방지
      if (
        isEventTargetInputElement(e) ||
        e.repeat ||
        e.metaKey ||
        e.ctrlKey ||
        e.altKey
      ) {
        return;
      }

      // Shift+M으로 snapping toggle
      if (e.shiftKey && e.code === 'KeyM') {
        e.preventDefault();
        const nextEnabled = !stateRef.current.isSnappingEnabled;
        setState({
          update: (state) =>
            state.isSnappingEnabled === nextEnabled
              ? state
              : toggleSnapping(state),
          commitToUndoStack: false,
        });
        saveSnappingEnabled(nextEnabled);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [setState, stateRef]);

  return null;
};
